/**
 * @generated SignedSource<<b77aa434e6f3fcd7dd6f98190d11ac32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionHeaderCollection$data = {
  readonly name: string;
  readonly " $fragmentType": "topicCollectionHeaderCollection";
};
export type topicCollectionHeaderCollection$key = {
  readonly " $data"?: topicCollectionHeaderCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionHeaderCollection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionHeaderCollection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Collection",
  "abstractKey": null
};

(node as any).hash = "42dda107b1bdc1d55b74a5908e0b9530";

export default node;
